import * as React from "react";
import styled from "styled-components";
const RenderError = styled.div`
  white-space: break-spaces;
`;
const ExportErrorPage = ({ error }) => /* @__PURE__ */ React.createElement(RenderError, null, error.stack);
export default ExportErrorPage;
